export const ItemTypes = {
    TABLE: 'table',
  }
  